// Author SWL
// Date 2025-05-28 12:34:58

class EmArchTool {
    constructor({
                    id = null,
                    type = '',
                    typeName = '',
                    detailType = '',
                    name = '',
                    identificationCode = '',
                    currentCode = '',
                    modelNumber = '',
                    description = '',
                    reportedLossLevel = '',
                    quantity = '',
                    borrowedQuantity = '',
                    repairQuantity = '',
                    unit = '',
                    binLocation = '',
                    usageStatus = '',
                    warehouseKeeper = '',
                    warehouseNumber = '',
                    headDepartment = '',
                    head = '',
                    department = '',
                    safeQuantity = '',
                    attachment = '',
                    remark = '',
                    attachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.type = type;
        this.typeName = typeName;
        this.detailType = detailType;
        this.name = name;
        this.identificationCode = identificationCode;
        this.currentCode = currentCode;
        this.modelNumber = modelNumber;
        this.description = description;
        this.reportedLossLevel = reportedLossLevel;
        this.quantity = quantity;
        this.borrowedQuantity = borrowedQuantity;
        this.repairQuantity = repairQuantity;
        this.unit = unit;
        this.binLocation = binLocation;
        this.usageStatus = usageStatus;
        this.warehouseKeeper = warehouseKeeper;
        this.warehouseNumber = warehouseNumber;
        this.headDepartment = headDepartment;
        this.head = head;
        this.department = department;
        this.safeQuantity = safeQuantity;
        this.attachment = attachment;
        this.remark = remark;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new EmArchTool();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.archive.emArchTool.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'typeName',
            label: 'label.em.archive.emArchTool.grid.type',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'detailType',
            label: 'label.em.archive.emArchTool.grid.detailType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'name',
            label: 'label.em.archive.emArchTool.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'identificationCode',
            label: 'label.em.archive.emArchTool.grid.identificationCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'epcCode',
            label: 'label.em.archive.emArchTool.grid.epcCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'currentCode',
            label: 'label.em.archive.emArchTool.grid.currentCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'modelNumber',
            label: 'label.em.archive.emArchTool.grid.modelNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'description',
            label: 'label.em.archive.emArchTool.grid.description',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reportedLossLevel',
            label: 'label.em.archive.emArchTool.grid.reportedLossLevel',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.em.archive.emArchTool.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                customClass: (row) => {
                    if (row.safeQuantity && row.safeQuantity >= row.quantity) return 'bg-danger text-white';
                    return ""
                },
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'borrowedQuantity',
            label: 'label.em.archive.emArchTool.grid.borrowedQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'repairQuantity',
            label: 'label.em.archive.emArchTool.grid.repairQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.em.archive.emArchTool.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'binLocation',
            label: 'label.em.archive.emArchTool.grid.binLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'usageStatus',
            label: 'label.em.archive.emArchTool.grid.usageStatus',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headDepartment',
            label: 'label.em.archive.emArchTool.grid.headDepartment',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'head',
            label: 'label.em.archive.emArchTool.grid.head',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'warehouseKeeper',
            label: 'label.em.archive.emArchTool.grid.warehouseKeeper',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'warehouseNumber',
            label: 'label.em.archive.emArchTool.grid.warehouseNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'department',
            label: 'label.em.archive.emArchTool.grid.department',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'safeQuantity',
            label: 'label.em.archive.emArchTool.grid.safeQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.em.archive.emArchTool.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.archive.emArchTool.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    typeFilter: '',
    detailTypeFilter: '',
    nameFilter: '',
    identificationCodeFilter: '',
    currentCodeFilter: '',
    modelNumberFilter: '',
    descriptionFilter: '',
    reportedLossLevelFilter: '',
    quantityFilter: '',
    borrowedQuantityFilter: '',
    repairQuantityFilter: '',
    unitFilter: '',
    binLocationFilter: '',
    usageStatusFilter: '',
    warehouseKeeperFilter: '',
    warehouseNumberFilter: '',
    headDepartmentFilter: '',
    headFilter: '',
    departmentFilter: '',
    safeQuantityFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'typeFilter',
        label: 'label.em.archive.emArchTool.filter.type',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchToolType'
            , correspondingField: 'id'
        }
    },
    {
        key: 'detailTypeFilter',
        label: 'label.em.archive.emArchTool.filter.detailType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'nameFilter',
        label: 'label.em.archive.emArchTool.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'identificationCodeFilter',
        label: 'label.em.archive.emArchTool.filter.identificationCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currentCodeFilter',
        label: 'label.em.archive.emArchTool.filter.currentCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'modelNumberFilter',
        label: 'label.em.archive.emArchTool.filter.modelNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionFilter',
        label: 'label.em.archive.emArchTool.filter.description',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reportedLossLevelFilter',
        label: 'label.em.archive.emArchTool.filter.reportedLossLevel',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.em.archive.emArchTool.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'borrowedQuantityFilter',
        label: 'label.em.archive.emArchTool.filter.borrowedQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'repairQuantityFilter',
        label: 'label.em.archive.emArchTool.filter.repairQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unitFilter',
        label: 'label.em.archive.emArchTool.filter.unit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binLocationFilter',
        label: 'label.em.archive.emArchTool.filter.binLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'usageStatusFilter',
        label: 'label.em.archive.emArchTool.filter.usageStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'headDepartmentFilter',
        label: 'label.em.archive.emArchTool.filter.headDepartment',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'headFilter',
        label: 'label.em.archive.emArchTool.filter.head',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'warehouseKeeperFilter',
        label: 'label.em.archive.emArchTool.filter.warehouseKeeper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'warehouseNumberFilter',
        label: 'label.em.archive.emArchTool.filter.warehouseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'departmentFilter',
        label: 'label.em.archive.emArchTool.filter.department',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'safeQuantityFilter',
        label: 'label.em.archive.emArchTool.filter.safeQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'type',
        label: 'label.em.archive.emArchTool.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchToolType'
            , correspondingField: 'id'
        }
    },
    {
        key: 'detailType',
        label: 'label.em.archive.emArchTool.entity.detailType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'name',
        label: 'label.em.archive.emArchTool.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'identificationCode',
        label: 'label.em.archive.emArchTool.entity.identificationCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currentCode',
        label: 'label.em.archive.emArchTool.entity.currentCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'modelNumber',
        label: 'label.em.archive.emArchTool.entity.modelNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'description',
        label: 'label.em.archive.emArchTool.entity.description',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reportedLossLevel',
        label: 'label.em.archive.emArchTool.entity.reportedLossLevel',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.em.archive.emArchTool.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'borrowedQuantity',
        label: 'label.em.archive.emArchTool.entity.borrowedQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'repairQuantity',
        label: 'label.em.archive.emArchTool.entity.repairQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.em.archive.emArchTool.entity.unit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binLocation',
        label: 'label.em.archive.emArchTool.entity.binLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'usageStatus',
        label: 'label.em.archive.emArchTool.entity.usageStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'headDepartment',
        label: 'label.em.archive.emArchTool.entity.headDepartment',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'head',
        label: 'label.em.archive.emArchTool.entity.head',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'warehouseKeeper',
        label: 'label.em.archive.emArchTool.entity.warehouseKeeper',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'warehouseNumber',
        label: 'label.em.archive.emArchTool.entity.warehouseNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'department',
        label: 'label.em.archive.emArchTool.entity.department',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'safeQuantity',
        label: 'label.em.archive.emArchTool.entity.safeQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.archive.emArchTool.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.em.archive.emArchTool.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]

export {
    EmArchTool, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
